import { Component, OnInit } from '@angular/core';
import { environment } from 'environments/environment';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { AuthserviceService } from 'app/auth/authservice.service';
import { MustMatch } from 'app/_helpers/validator';
import { TestsocketService } from 'app/services/testsocket.service';

@Component({
  selector: 'app-my-profile',
  templateUrl: './my-profile.component.html',
  styleUrls: ['./my-profile.component.scss']
})
export class MyProfileComponent implements OnInit {
  profile: any;
  url = environment.url;
  s3url = environment.s3url;
  show_change_pas = false;
  password_change_form: FormGroup;
  loading: boolean;

  constructor(private authService: AuthserviceService, private _formbuilder: FormBuilder, private toast: ToastrService, private authservice: AuthserviceService
    // , private socket: TestsocketService
    ) {

    // console.log("MyProfileComponent");
    // this.socket.on('laravel_database_chat').subscribe(data => {
    //   console.log(data);
    // });
    // console.log(socket.getMessage());
    
  }

  ngOnInit() {
    this.authService.getUser().subscribe((res: any) => {
      console.log(res);
      
      this.profile = res.user;
    })
    this.password_change_form = this._formbuilder.group({
      current_password: new FormControl('', Validators.required),
      password: ['', [Validators.required, Validators.minLength(6)]],
      password_confirmation: new FormControl(''),
    },
      {
        validator: MustMatch('password', 'password_confirmation')
      })
  }

  onPasswordChange() {
    if (!this.password_change_form.valid) {
      return;
    }

    if (this.password_change_form.value.current_password === this.password_change_form.value.password) {
      this.toast.warning('Use password not used previously')
      return;
    }

    console.log('form submitted');
    this.loading = true;
    this.authservice.changePassword(this.password_change_form.value).subscribe(res => {
      console.log(res);
      // this.message.showNotification('success', res.message);
      this.toast.success(res.message, 'success');
      this.loading = false;
      // this.pass_change = true;
      this.show_change_pas = false;
      this.password_change_form.reset();
    },
      error => {
        console.error(error);
        // this.message.showNotification('danger', error.error.message);
        this.toast.error(error.error.message, 'Failed');
        this.loading = false;
        this.password_change_form.reset();
      })
  }
}
